import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import NonSlrTable from './tables/NonSlrTable';
import { DatePicker, Input, Select, TimePicker, Tooltip } from 'antd';
import Title from '../ui/Title';
import FormActionButton from '../ui/FormActionButton';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const NonSlrMoneyMarket = () => {
    const [product, setProduct] = useState();
    const [tenr, setTenr] = useState();
    const [tenure, setTenure] = useState();
    const [isCPCD, setIsCPCD] = useState();
    const [startDate, setStartDate] = useState({
        dateValue: '',
        dateString: '',
    });
    const [endDate, setEndDate] = useState({
        dateValue: '',
        dateString: '',
    });
    const [startTime, setStartTime] = useState({
        timeValue: '',
        timeString: '',
    });
    const [endTime, setEndTime] = useState({
        timeValue: '',
        timeString: '',
    });
    const [productList, setProductList] = useState([]);

    const [dataSource, setDataSource] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const cpcdAllowed = isCPCD === 0 || isCPCD === 1;

    // Get customer ID list
    const cpcdList = [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' },
    ];

    // Get product list
    useEffect(() => {
        if(cpcdAllowed) {
            (async () => {
                try {
                    const details = {
                        'IsCPCD': isCPCD,
                    };
                
                    let formBody = [];
                    for (let property in details) {
                    let encodedKey = encodeURIComponent(property);
                    let encodedValue = encodeURIComponent(details[property]);
                    formBody.push(encodedKey + "=" + encodedValue);
                    }
                    formBody = formBody.join("&");

                    const response = await fetch(`${API_BASE_URL}/moneymarket/products?IsCPCD=${isCPCD}`, {
                        method: 'POST',
                        headers: { 
                            'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                        },
                        body: formBody,
                    });
                    const responseData = await response.json();
                    setProductList(responseData.data.map((product) => (
                        { value: product.product, label: product.product }
                    )));
                } catch (error) {
                    setIsError(true);
                }
            })();
        }
    }, [isCPCD]);

    // FETCH DATA
    useEffect(() => {
        let queryParams = `?`;
        if ((product || tenure || cpcdAllowed || startDate.dateValue || endDate.dateValue || endTime.timeValue)) {
            if (cpcdAllowed) {
                queryParams = queryParams.concat(`IsCPCD=${isCPCD}&`);
            }
            if (product) {
                queryParams = queryParams.concat(`Product=${product}&`);
            }
            if (tenure) {
                queryParams = queryParams.concat(`Tenor=${tenure}&`);
            }
            if (startDate.dateString) {
                queryParams = queryParams.concat(`start_date=${startDate.dateString}&`);
            }
            if (endDate.dateString) {
                queryParams = queryParams.concat(`end_date=${endDate.dateString}&`);
            }
            if (startTime.timeString) {
                queryParams = queryParams.concat(`start_time=${startTime.timeString}&`);
            }
            if (endTime.timeString) {
                queryParams = queryParams.concat(`end_time=${endTime.timeString}&`);
            }
            queryParams = queryParams.slice(0, -1);

            if( !(queryParams.includes('IsCPCD') && queryParams.includes('Product') || 
                queryParams.includes('IsCPCD') && queryParams.includes('tenure')) ) {
                // DO NOTHING
            } else {
                fetchMarketPrice();
            }
        }
        if((!product && !tenure && !cpcdAllowed && !startDate.dateValue && !endDate.dateValue && !startTime.timeValue && !endTime.timeValue)) {
            // fetchMarketPrice();
            setDataSource([]);
        }
        
        async function fetchMarketPrice() {
            try {
                setIsLoading(true);
                setIsError(false);
                const response = await fetch(`${API_BASE_URL}/moneymarket/list${queryParams}`, {
                    method: 'POST',
                    headers: { 
                        'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                });
                const responseData = await response.json();
                if(responseData.code === 200) {
                    setDataSource(responseData.data.map((item) => ({
                        ...item,
                        key: item.updated_on,
                    })));
                } else {
                    setDataSource([]);
                }
            } catch (error) {
                // Handle error
                setIsError(true);
                setIsLoading(false);
            }  
            setIsLoading(false);
        };

    }, [isCPCD, product, tenure, startDate, endDate, endTime]);

    useEffect(() => {
        if(!startDate.dateValue) {
            setEndDate({
                dateValue: null,
                dateString: '',
            });
        }
        if(!startTime.timeValue) {
            setEndTime({
                timeValue: null,
                timeString: '',
            });
        }
    }, [startDate, startTime]);

    const resetHandler = () => {
        setIsCPCD();
        setProduct();
        setTenure();
        setStartDate({
            dateValue: null,
            dateString: '',
        });
        // setEndDate({
        //     dateValue: null,
        //     dateString: '',
        // });
        setStartTime({
            timeValue: null,
            timeString: '',
        });
        setEndTime({
            timeValue: null,
            timeString: '',
        });
        // setDataSource([]);
    }

    const productListDisabled = !cpcdAllowed;
    const tenureListDisabled = !cpcdAllowed;
    const startDateDisabled = !product && !tenure;
    // const endDateDisabled = !startDate.dateString;
    const timePickerDisabled = (!startDate.dateString);
    const endTimeDisabled = !startTime.timeString;

    return (
        <Wrapper>
            <Title>Non SLR Money Market</Title>
            <SelectionGroup>
                <SelectionWrapper>
                    <Select
                        placeholder="Is CPCD"
                        style={{ width: '100%'}}
                        size='large'
                        onChange={(value) => setIsCPCD(value)}
                        value={isCPCD}
                        options={cpcdList}
                        allowClear
                    />
                </SelectionWrapper>
                <SelectionWrapper>
                    <Tooltip {...(productListDisabled && {title: 'Please select a Customer'})}>
                        <Select
                            placeholder="Select Product"
                            style={{ width: '100%'}}
                            size='large'
                            onChange={(value) => setProduct(value)}
                            value={product}
                            options={productList}
                            allowClear
                            disabled={productListDisabled}
                        />
                    </Tooltip>
                </SelectionWrapper>
                <SelectionWrapper>
                    <Tooltip {...(tenureListDisabled && {title: 'Please select a Customer'})}>
                    <div className='input-control'>
                        <Input
                            onChange={(e) => setTenr(e.target.value)} 
                            onBlur={(e) => setTenure(e.target.value)}
                            value={tenr}
                            size='large' 
                            placeholder='Tenure'
                            disabled={tenureListDisabled}
                        />
                    </div>
                    </Tooltip>
                </SelectionWrapper>
                </SelectionGroup>
                <div className="date-time">
                    <DateGroup>
                        <Tooltip {...(startDateDisabled && {title: 'Please select a Customer'})}>
                            <DatePicker 
                                onChange={(date, dateString) => setStartDate({dateValue: date, dateString: dateString})} 
                                value={startDate.dateValue}
                                size='large' 
                                style={{width: '100%', borderRadius: '0.2rem'}} 
                                placeholder='Select Start Date'
                                allowClear
                                disabled={startDateDisabled}
                            />
                        </Tooltip>
                    </DateGroup>
                    {/* <DateGroup>
                        <Tooltip {...(endDateDisabled && {title: 'Please select start date'})}>
                            <DatePicker 
                                onChange={(date, dateString) => setEndDate({dateValue: date, dateString: dateString})} 
                                value={endDate.dateValue}
                                size='large' 
                                style={{width: '100%', borderRadius: '0.2rem'}} 
                                placeholder='Select End Date'
                                allowClear
                                disabled={endDateDisabled}
                            />
                        </Tooltip>
                    </DateGroup> */}
                        <TimeGroup>
                            <Tooltip {...(timePickerDisabled && {title: 'Please select start date only'})}>
                                <TimePicker  
                                    onChange={(time, timeString) => setStartTime({timeValue: time, timeString})} 
                                    value={startTime.timeValue} 
                                    size='large'
                                    style={{width: '100%', borderRadius: '0.2rem'}}
                                    placeholder='Select Start Time'
                                    allowClear
                                    disabled={timePickerDisabled}
                                />
                            </Tooltip>
                            </TimeGroup>

                            <TimeGroup>
                            <Tooltip {...(endTimeDisabled && {title: 'Please select start time'})}>
                                <TimePicker  
                                    onChange={(time, timeString) => setEndTime({timeValue: time, timeString})} 
                                    value={endTime.timeValue}
                                    size='large'
                                    style={{width: '100%', borderRadius: '0.2rem'}}
                                    placeholder='Select End Time'
                                    allowClear
                                    disabled={endTimeDisabled}
                                />
                            </Tooltip>
                        </TimeGroup>
                        {/* <DateGroup /> */}
                </div>
                <Action>
                    <div>
                        <FormActionButton bg='#ff6b6b' onClick={resetHandler} >Reset</FormActionButton>
                    </div>
                </Action>
            <NonSlrTable dataSource={dataSource} isError={isError} isLoading={isLoading} />
        </Wrapper>
    );
}

export default NonSlrMoneyMarket;

const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    .control {
        label {
            font-weight: bold;
            font-size: 1.5rem;
            letter-spacing: 0.0625rem;
            color: #36454F;
        }
    }
    .date-time {
        display: flex;
        justify-content: space-between;
        /* gap: 10rem; */
        gap: 2rem;
        margin-bottom: 2.5rem;
    }
    .ant-select .ant-select-selector {
        border-radius: 0.2rem;
    }
    .input-control {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 3rem;
    }
    .ant-input {
        border-radius: 0.2rem;
    }
    .ant-input:focus {
        border-color: ${({theme}) => theme.colors.primary};
    }
`;
const SelectionGroup = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    margin-bottom: 2.5rem;
`;
const SelectionWrapper = styled.div`
    flex: 1;
    /* display: flex; */
    max-width: 40rem;
`;
const DateGroup = styled.div`
    flex: 1;
    display: flex;
    max-width: 40rem;
    gap: 2rem;
`;
const TimeGroup = styled.div`
    flex: 1;
    display: flex;
    max-width: 40rem;
    gap: 2rem;
`;
const Action = styled.div`
    display: flex;
    justify-content: end;
`;
